import Swiper from "swiper";

export default () => {
  
  servicePageLogo();
  
  function servicePageLogo() {
    let slider = document.querySelector(".h-logo__slider");
    if (slider) {
      let mainSlider = new Swiper(slider, {
        wrapperClass: "h-logo__slider-wrapper",
        slideClass: "h-logo__slide",
        slidesPerView: 1,
        centeredSlides:true,
        touchStartPreventDefault: false,
        loop: true,
        speed: 700,
        autoplay:false,
        navigation: false,
        autoHeight: false,
         autoplay: {
          delay: 4000,
        },
        breakpoints: {
          600: {
            slidesPerView: 4.5,
            autoHeight: false,
          },
        },
        lazy: {
          loadPrevNext: true,
        }
    });
    }
  }
};
